export const ADMIN_TOKEN_KEY = "portfolio_admin_token";
export const ADMIN_EMAIL_KEY = "portfolio_admin_email";

export function getAdminToken(): string | null {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
}

export function setAdminToken(token: string) {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken() {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getAdminEmail(): string {
  return localStorage.getItem(ADMIN_EMAIL_KEY) || "admin@ugurcanuzunkaya.com";
}

export function setAdminEmail(email: string) {
  localStorage.setItem(ADMIN_EMAIL_KEY, email);
}

export function clearAdminEmail() {
  localStorage.removeItem(ADMIN_EMAIL_KEY);
}

export async function adminFetch(endpoint: string, data?: any, method?: string): Promise<any> {
  const token = getAdminToken();
  const actualMethod = method || (data !== undefined ? "POST" : "GET");

  const headers: Record<string, string> = {
    "Authorization": token ? `Bearer ${token}` : ""
  };

  const options: RequestInit = {
    method: actualMethod,
    headers
  };

  if (actualMethod !== "GET" && actualMethod !== "HEAD") {
    headers["Content-Type"] = "application/json";
    if (data !== undefined) {
      options.body = JSON.stringify(data);
    }
  }

  const response = await fetch(endpoint, options);

  if (response.status === 401) {
    clearAdminToken();
    window.location.reload();
    throw new Error("Session expired. Please log in again.");
  }

  const result = (await response.json()) as any;
  if (!response.ok || !result.success) {
    throw new Error(result.error || "Operation failed");
  }

  return result;
}
